import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import BlogForm from "../../../components/admin/BlogForm";
import Loader from "../../../components/common/Loader";
import { getAdminBlog, updateBlog } from "../../../services/blogService";
import AdminBlogLayout from "./AdminBlogLayout";

const EditBlog = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getAdminBlog(id).then(setBlog).catch(() => setError("Blog not found."));
  }, [id]);

  const save = async (payload) => {
    setSaving(true);
    setError("");
    try {
      const updated = await updateBlog(id, payload);
      navigate(`/admin/blog/edit/${updated.id}`);
      setBlog(updated);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not update blog.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminBlogLayout
      title="Edit Blog"
      action={blog && <Link to={`/blog/${blog.slug}`} className="border border-white/20 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:border-white">View Blog</Link>}
    >
      {error && <div className="mb-6 border border-cynos-red/40 bg-cynos-red/10 p-4 font-mono text-xs uppercase tracking-[0.18em] text-red-200">{error}</div>}
      {!blog ? <Loader label="Loading blog..." /> : <BlogForm initial={blog} saving={saving} onSubmit={save} submitLabel="Update Blog" />}
    </AdminBlogLayout>
  );
};

export default EditBlog;
